import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Layout from "@/components/layout/Layout";
import Home from "@/pages/Home";
import Solutions from "@/pages/Solutions";
import Licara from "@/pages/Licara";
import About from "@/pages/About";
import Careers from "@/pages/Careers";
import Faq from "@/pages/Faq";
import Contact from "@/pages/Contact";
import DemoRequest from "@/pages/DemoRequest";
import Admin from "@/pages/Admin";
import NotFound from "@/pages/NotFound";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname]);
  return null;
}

function App() {
  return (
    <div className="App dark">
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<Home />} />
            <Route path="/solutions" element={<Solutions />} />
            <Route path="/solutions/licara" element={<Licara />} />
            <Route path="/solutions/web-design" element={<Navigate to="/solutions" replace />} />
            <Route path="/products" element={<Navigate to="/solutions/licara" replace />} />
            <Route path="/products/licara" element={<Navigate to="/solutions/licara" replace />} />
            <Route path="/about" element={<About />} />
            <Route path="/careers" element={<Careers />} />
            <Route path="/faq" element={<Faq />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/demo" element={<DemoRequest />} />
            <Route path="*" element={<NotFound />} />
          </Route>
          <Route path="/admin" element={<Admin />} />
        </Routes>
      </BrowserRouter>
      <Toaster
        position="top-right"
        toastOptions={{
          classNames: {
            toast:
              "bg-card border border-border text-foreground",
          },
        }}
      />
    </div>
  );
}

export default App;
